import { createFileRoute } from '@tanstack/react-router';

import { SupplierMemberDetailPage } from '../user/detail/SupplierMemberDetailPage';

export const Route = createFileRoute('/_app/supplier-groups/$groupId/members/$userId')({
    component: SupplierMemberDetailPage,
});
